import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "h-full flex flex-col justify-between"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-light font-bold my-3" }, " ‐ ", -1)
const _hoisted_3 = {
  key: 0,
  class: "text-light my-3"
}
const _hoisted_4 = { class: "h-10 my-3 px-0.5" }
const _hoisted_5 = {
  key: 1,
  class: "text-light"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sale_price_column = _resolveComponent("sale-price-column")!
  const _component_percent_input = _resolveComponent("percent-input")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-row bg-white", {'sale-prices-table__section--selected': _ctx.isSelected}])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weightBrackets, (weightBracket) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "flex flex-1 flex-col py-5 text-center",
        style: {"min-width":"100px"},
        key: `sale-price-cost-price-${_ctx.salePriceRow.id}-weight-${weightBracket}`
      }, [
        (_ctx.salePriceRow.weightBrackets.has(weightBracket) && _ctx.salePriceRow.weightBrackets.get(weightBracket).weightBracket.costPrice.amount !== null)
          ? (_openBlock(), _createBlock(_component_sale_price_column, {
              key: 0,
              "weight-bracket": _ctx.salePriceRow.weightBrackets.get(weightBracket).weightBracket,
              "is-disabled": false,
              "sale-price-row": _ctx.salePriceRow
            }, null, 8, ["weight-bracket", "sale-price-row"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              (_ctx.showCostPrice)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, " ‐ "))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                (_ctx.showGrossMargin && _ctx.isProposalEditable)
                  ? (_openBlock(), _createBlock(_component_percent_input, {
                      key: 0,
                      disabled: true
                    }))
                  : _createCommentVNode("", true),
                (_ctx.showGrossMargin && !_ctx.isProposalEditable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, " ‐ "))
                  : _createCommentVNode("", true)
              ])
            ]))
      ]))
    }), 128))
  ], 2))
}